import { INPUT_TYPES }                                                                                                     from '../../../../constants/FormEnums';
import { PROJECT_DESCRIPTION_INFO, PROJECT_MILESTONE_INFO, ProjectDetailField, ProjectMilestoneField, ProjectModelFields } from '../../../../constants/ProductEnums';
import { SurveyQuestionLayoutItem }                                                                                        from './SurveyQuestionLayout';

/*
Notes: This file formats static project model attribute data
	   into an intake question field object in order to have
	   them mingle with with actual system intake questions
	   pulled from the DB. Anytime you need to represent
	   these data pieces as questions, like in a survery,
	   reach for this file, instead of the enums.
	   
- Enums are defined from the file `constants/ProductEnums
- Default values are defined from the file `lang/termDictionaries`
- Project values are defined from the DEM, and used through `useProjectTermDictionary.getTerm` hook
*/

// @ts-ignore
export const fieldQuestions: Record<ProjectModelFields, Partial<SurveyQuestionLayoutItem>> = {
	
	/* STATIC PROJECT QUESTIONS */
	
	// Project Name
	[ PROJECT_DESCRIPTION_INFO.NAME.PROJECT_FIELD ]: {
		questionText: PROJECT_DESCRIPTION_INFO.NAME.LABEL,
		description:  PROJECT_DESCRIPTION_INFO.NAME.DESCRIPTION,
		inputType:    INPUT_TYPES.SHORT_TEXT
	},
	
	// Asset Name
	[ PROJECT_DESCRIPTION_INFO.ASSET_NAME.PROJECT_FIELD ]: {
		questionText: PROJECT_DESCRIPTION_INFO.ASSET_NAME.LABEL,
		description:  PROJECT_DESCRIPTION_INFO.ASSET_NAME.DESCRIPTION,
		inputType:    INPUT_TYPES.SHORT_TEXT
	},
	
	// Asset Indication
	[ PROJECT_DESCRIPTION_INFO.ASSET_INDICATION.PROJECT_FIELD ]: {
		questionText: PROJECT_DESCRIPTION_INFO.ASSET_INDICATION.LABEL,
		description:  PROJECT_DESCRIPTION_INFO.ASSET_INDICATION.DESCRIPTION,
		inputType:    INPUT_TYPES.LONG_TEXT
	},
	
	// Custom Start Date
	[ PROJECT_DESCRIPTION_INFO.CUSTOM_START_DATE.PROJECT_FIELD ]: {
		questionText: PROJECT_DESCRIPTION_INFO.CUSTOM_START_DATE.LABEL,
		description:  PROJECT_DESCRIPTION_INFO.CUSTOM_START_DATE.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	/* PROJECT FIXED DATES QUESTIONS */
	
	// Investigational New Drug Application Filing
	[ PROJECT_MILESTONE_INFO.INVESTIGATIONALNEWDRUGAPPLICATIONFILING.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.INVESTIGATIONALNEWDRUGAPPLICATIONFILING.LABEL,
		description:  PROJECT_MILESTONE_INFO.INVESTIGATIONALNEWDRUGAPPLICATIONFILING.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// Phase 2 Trial Start Date
	[ PROJECT_MILESTONE_INFO.P2TRIALSTART.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.P2TRIALSTART.LABEL,
		description:  PROJECT_MILESTONE_INFO.P2TRIALSTART.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// Phase 2 Trial Results Date
	[ PROJECT_MILESTONE_INFO.P2TRIALDATA.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.P2TRIALDATA.LABEL,
		description:  PROJECT_MILESTONE_INFO.P2TRIALDATA.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// Phase 3 Trial Start Date
	[ PROJECT_MILESTONE_INFO.P3TRIALSTART.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.P3TRIALSTART.LABEL,
		description:  PROJECT_MILESTONE_INFO.P3TRIALSTART.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// Phase 3 Trial Results Date
	[ PROJECT_MILESTONE_INFO.P3TRIALDATA.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.P3TRIALDATA.LABEL,
		description:  PROJECT_MILESTONE_INFO.P3TRIALDATA.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// NDA Submission Date
	[ PROJECT_MILESTONE_INFO.NDASUBMISSION.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.NDASUBMISSION.LABEL,
		description:  PROJECT_MILESTONE_INFO.NDASUBMISSION.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// NDA Approval Date
	[ PROJECT_MILESTONE_INFO.NDAAPPROVAL.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.NDAAPPROVAL.LABEL,
		description:  PROJECT_MILESTONE_INFO.NDAAPPROVAL.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
	
	// Launch Date Readiness
	[ PROJECT_MILESTONE_INFO.LAUNCHDATE.PROJECT_FIELD ]: {
		questionText: PROJECT_MILESTONE_INFO.LAUNCHDATE.LABEL,
		description:  PROJECT_MILESTONE_INFO.LAUNCHDATE.DESCRIPTION,
		inputType:    INPUT_TYPES.DATE
	},
};
